import Popup from '@Components/Popups/Popup'
import Button from '@Components/Buttons/Button'
import React, { useContext } from 'react'
import { deleteSongwriter } from '@App/api/routes/songwriter/songwriter'
import { StoresContext } from '@App/contexts'

interface DeleteSongwriterPopupProps {
    id?: string
    totalWorks: number
    setDisplayPopup(value: boolean): void
}

const DeleteSongwriterPopup = ({ id, totalWorks, setDisplayPopup }: DeleteSongwriterPopupProps) => {
    const { popupStore } = useContext(StoresContext)

    const onDelete = async () => {
        if (id) {
            try {
                await deleteSongwriter(id)
                popupStore.setAlertData('Success! Your Songwriter has been deleted', false)
                setDisplayPopup(false)
            } catch (exception) {
                popupStore.setAlertFromError(exception)
            }
        }
    }

    return (
        <>
            {totalWorks !== 0 ? (
                <Popup onClose={() => setDisplayPopup(false)} showClose>
                    <h3>
                        The Songwriter has {totalWorks.toLocaleString()} songs in their catalog and cannot be deleted
                        yet
                    </h3>
                    <div>You'll be able to delete this songwriter once all the songs have been removed.</div>
                    <div>
                        Remove the songs by going to the 'My Writer Names' page and switching the 'In Catalog' toggle to
                        "no".
                    </div>
                    <Button mainColor type="primary" onClick={() => setDisplayPopup(false)}>
                        Close
                    </Button>
                </Popup>
            ) : (
                <Popup onClose={() => setDisplayPopup(false)} showClose>
                    <h3>Are you sure you want to delete this Songwriter?</h3>
                    <div>Deleting a songwriter is permanent and cannot be undone</div>
                    <div className="delete-songwriter-button">
                        <Button mainColor type="primary" onClick={() => onDelete()}>
                            Delete
                        </Button>
                        <Button mainColor type="secondary" onClick={() => setDisplayPopup(false)}>
                            Cancel
                        </Button>
                    </div>
                </Popup>
            )}
        </>
    )
}

export default DeleteSongwriterPopup
